import moment from 'moment';
import { docTypes } from '../docTypes';
export var docTypeValueValidator = function (docType, value) { var _a; return !!value.match((_a = docTypes[docType]) === null || _a === void 0 ? void 0 : _a.validator); };
export var emailValidator = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};
export var minDateValidator = function (minDate, selectedDate, dateFormat) {
    return minDate >= moment(selectedDate, dateFormat);
};
export var phoneValidator = function (phone) {
    var re = /(^[1-9][0-9]{9}$)|(^[0][1-9]{9,11}$)/;
    return re.test(String(phone).toLowerCase());
};
export var validateForm = function (form) {
    var copyForm = Object.assign({}, form);
    Object.keys(form).forEach(function (formField) {
        var _a, _b;
        var inputField = form[formField];
        var isValid = !inputField.error &&
            !!((inputField.isRequired && ((_a = inputField.value) === null || _a === void 0 ? void 0 : _a.length)) || !inputField.isRequired);
        if (inputField.validateBy && inputField.validateKey && form[inputField.validateKey]) {
            isValid =
                isValid && !!inputField.validateBy(form[inputField.validateKey].value, inputField.value);
        }
        else if (inputField.validateBy)
            isValid = isValid && !!inputField.validateBy(inputField.value);
        isValid = isValid || !((_b = inputField.value) === null || _b === void 0 ? void 0 : _b.length);
        copyForm[formField].error = !isValid;
    });
    return copyForm;
};
export var defaultValidateFormFields = function (form) {
    var isValid = true;
    var copyForm = validateForm(form);
    Object.values(copyForm).forEach(function (inputField) {
        var _a;
        isValid =
            isValid &&
                !inputField.error &&
                !!((inputField.isRequired && ((_a = inputField.value) === null || _a === void 0 ? void 0 : _a.length)) || !inputField.isRequired);
    });
    return { isValid: isValid, form: copyForm };
};
//# sourceMappingURL=validators.js.map